import { plural } from "@amber/contracts";
import { AppLink, formatCount } from "@amber/ui";
import type { HomeResponse } from "@amber/application/contracts";
import { Count, Panel } from "./parts";

export function CoveragePanel({ data }: { data: HomeResponse }) {
  const c = data.coverage;
  return (
    <Panel
      labelledBy="home-coverage"
      title="Coverage"
      lead="Known missing intervals"
      link={{ href: c.open_gaps.href, label: "Gaps" }}
    >
      <p className="m-0">
        <span className="font-mono text-2xl font-semibold">
          <Count href={c.open_gaps.href} count={c.open_gaps.count} team={false} label="Open gaps" />
        </span>{" "}
        open {c.open_gaps.count === 1 ? "gap" : "gaps"}
        {c.oldest_days !== null ? (
          <span className="text-muted"> · oldest open for {plural(c.oldest_days, "day", { format: formatCount })}</span>
        ) : null}
      </p>
      {c.by_reason.length > 0 ? (
        <p className="m-0 mt-1 text-md text-muted">
          {c.by_reason.map((r) => `${formatCount(r.count)} ${r.label}`).join(" · ")}
        </p>
      ) : null}
      {c.longest ? (
        <p className="m-0 mt-1.5 text-md text-muted">
          Longest missing interval: {plural(c.longest.days, "day", { format: formatCount })} (
          {new Date(c.longest.from).toLocaleDateString("en-GB", { day: "numeric", month: "short" })}–
          {new Date(c.longest.to).toLocaleDateString("en-GB", { day: "numeric", month: "short" })}).
        </p>
      ) : null}
      {c.open_gaps.count > 0 ? (
        <p className="m-0 mt-1.5 text-md text-muted">
          <b className="font-strong text-fg">{formatCount(c.need_someone)}</b> need someone; the rest retry or backfill
          automatically.
        </p>
      ) : null}
      {c.extension ? (
        <p className="m-0 mt-1.5 text-md">
          <AppLink href={c.extension.href} className="text-link">
            {c.extension.text}
          </AppLink>
        </p>
      ) : null}
      <p className="m-0 mt-2.5 border-t border-divider pt-2 text-sm text-muted">
        Coverage is shown as “complete through” dates and open gaps, never as a percentage.
      </p>
    </Panel>
  );
}
